import { type FacetData, type SearchResultRow } from "~/utils/models";
import { type TabularColumnConfig } from "~/features/search/models/models";
import { type SortState } from "~/features/search/redux/reducer/sortReducer";
import { HSA_PAGE_SIZE } from "~/features/selectionAssistant/housing/constants";
import { type FilterDefinitionV2 } from "~/features/selectionAssistant/housing/types/FilterDefinitionV2";

export interface SAStateConfiguration {
  //  comes from search/facets/configuration/XXX endpoint
  metricColumnConfig: HSATabularColumnConfig[];
  // comes from search/facets/configuration/XXX endpoint
  imperialColumnConfig: HSATabularColumnConfig[];
  // comes from search/clustergroups endpoint
  filterConfig: Record<string, FilterDefinitionV2>;
}

export interface SAStateResults {
  results: SearchResultRow[];
  totalResults: number;
  pageAmount: number;
  pageSize?: number;

  facetsByCode: Record<string, FacetData>;
}

export enum SearchReason {
  FILTER,
  PAGINATION,
  SORTING,
}

export interface SAState {
  initialised: boolean; // Initial data downloaded
  inFlight: boolean; // Waiting for a search result
  lastSearchReason: SearchReason; // What triggered the search
  error: boolean;

  currentPage: number;
  sort: SortState;

  configuration: SAStateConfiguration;
  searchResults: SAStateResults;
}

export const INITIAL_HOUSING_SA_STATE: SAState = {
  initialised: false,
  inFlight: true,
  lastSearchReason: SearchReason.FILTER,
  error: false,

  configuration: {
    metricColumnConfig: [],
    imperialColumnConfig: [],
    filterConfig: {},
  },

  searchResults: {
    results: [],
    totalResults: 0,
    pageAmount: 0,
    pageSize: HSA_PAGE_SIZE,
    facetsByCode: {},
  },

  currentPage: 0,
  sort: {
    availableSorts: [],
    selectedCode: "",
    selectedDirection: null,
  },
};

export interface HSATabularColumnConfig extends TabularColumnConfig {
  assistantLabel: string;
}
